// extracted by mini-css-extract-plugin
module.exports = {"starIcon":"rating-with-reviews_starIcon__rPrPp","reviewsCount":"rating-with-reviews_reviewsCount__GKmO5","commentIcon":"rating-with-reviews_commentIcon__j0M1V"};